<ng-container *transloco="let t; read: 'accounts'">
<div class="rounded-lg fixActionRow" id="addFeatureDialog">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{headerName}}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <form class="grid grid-cols-1 gap-10 py-5 px-2" [formGroup]="featureForm">
      <div class="col-span-1">
        <label class="font-normal" for="FeatureName">{{ t('features.featureName') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput
            [placeholder]="t('features.featureNamePlaceholder')"
            autocomplete="off"
            id="featureName"
            type="text"
            formControlName="permissionName"
            maxlength="100"
            required>
        </mat-form-field>
      </div>

      <div class="col-span-1">
        <label class="font-normal" for="featureDescription">{{ t('features.featureDescription') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput
            [placeholder]="t('features.featureDescriptionPlaceholder')"
            autocomplete="off"
            id="featureDescription"
            type="text"
            formControlName="permissionDescription"
            maxlength="100"
            required>
        </mat-form-field>
      </div>

    </form>

  </div>
  <div mat-dialog-actions class="flex justify-end align-bottom">
    <button mat-button mat-dialog-close>{{ t('common.cancel') }}</button>
    @if (featureForm.valid) {
      <drdp-btn mat-button [mat-dialog-close]="onSubmit()" [disabled]="false" cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
    }
    @if (!featureForm.valid) {
      <drdp-btn mat-button [disabled]="true" cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
    }
  </div>
</div>
</ng-container>
